import { useRef } from "react";
import { useTranslation } from "react-i18next";
import { useJoinBaseCreate } from "./handlers";
import Input from "components/input";
import { regEmail, regNum } from "components/utils/comm";
import PhoneSelect from "components/select/phone/phone";
import LodGrpNo from "components/select/lod/lodGrp";
import { useBaseJoinParamContext } from "./context";
import useAlertStore from "store/alert";

export default function JoinBasePage() {
  const { t } = useTranslation();

  const onSetAlert = useAlertStore((state) => state.onSetAlert);

  const formRef = useRef<HTMLFormElement>(null);
  const { param, onChange, onSelect } = useBaseJoinParamContext();

  const { onSubmit } = useJoinBaseCreate();

  const Inner = () => {
    return (
      <div>
        아래 이메일 주소로 인증 메일이 발송됩니다.
        <h4 className="text-red-300 font-bold">[ {param.manEmlId} ]</h4>
        이메일 주소가 정확한지 다시 한번 확인해주세요.
      </div>
    );
  };

  return (
    <>
      <form
        id="base-join"
        ref={formRef}
        onSubmit={(e) => {
          e.preventDefault();
          const form = e.currentTarget;
          // 등록된 메일이 정확한지 다시 확인 필요
          onSetAlert({
            isOpen: true,
            innerHtml: (
              <>
                <Inner />
              </>
            ),
            cnclBtn: true,
            onSetConfirm: () => {
              onSubmit(form);
            },
          });
        }}
      >
        <h2>{t("join_dft_regi")}</h2>
        <div className="flex py-4"></div>
        <ul className="flex col gap-6">
          <li className="relative mb-4">
            <label htmlFor="" className="font-bold pb-4">
              {t("lbl_lod_grp_cmm")}
            </label>
            <LodGrpNo
              required
              select={(option) => onSelect("lodGrpNo", option)}
              isReset={!param.lodGrpNo}
            />
          </li>
          <li>
            <label htmlFor="" className="font-bold">
              {t("lbl_en_sfnm_cmm")}
            </label>
            <Input
              type="text"
              name="manSurnm"
              required
              value={param.manSurnm}
              validatyTxt="영문성을 입력하에 주세요."
              onChange={(e) => onChange("manSurnm", e.currentTarget.value)}
            />
          </li>
          <li>
            <label htmlFor="" className="font-bold">
              {t("lbl_en_fsnm_cmm")}
            </label>
            <Input
              name="manFstnm"
              required
              validatyTxt="영문이름을 입력하에 주세요."
              value={param.manFstnm}
              onChange={(e) => onChange("manFstnm", e.currentTarget.value)}
            />
          </li>
          <li>
            <label htmlFor="" className="font-bold">
              {t("lbl_eml_id_cmm")}
            </label>
            <Input
              name="manEmlId"
              required
              value={param.manEmlId}
              onBlur={(e) => {
                const value = e.currentTarget.value;

                if (!regEmail.test(value)) {
                  e.currentTarget.style.color = "#ef233c";

                  return;
                }
                e.currentTarget.style.color = "#010101";
              }}
              validatyTxt="정확한 형식의 이메일을 작성하세요."
              onChange={(e) => onChange("manEmlId", e.currentTarget.value)}
            />
          </li>
          <li>
            <label htmlFor="" className="font-bold">
              {t("lbl_phone_cmm")}
            </label>
            <div className="flex gap-3 ">
              <PhoneSelect
                styles="flex-1 bg-gray-100 min-w-[100px] border-0"
                ulStyles="top-8"
                isReset={param.mobCntyCd === "+82"}
                onSelect={(mobCntyCd) => onSelect("mobCntyCd", "+" + mobCntyCd)}
              />
              <Input
                name="mobNo"
                placeholder={t("place_phone_cmm")}
                required
                maxLength={12}
                value={param.mobNo}
                onChange={(e) => {
                  const value = e.currentTarget.value;
                  if (!regNum.test(value)) {
                    e.currentTarget.value = "";
                    return;
                  }
                  if (regEmail.test(value)) {
                    e.currentTarget.style.color = "#010101";
                    return;
                  }
                  onChange("mobNo", value);
                }}
                validatyTxt="전화번호를 입력하여 주세요."
              />
            </div>
          </li>
        </ul>
        <div className="flex justify-center mt-[40px] ">
          <button
            type="submit"
            className="btn _f_14 bg-red-400"
            // disabled={isAble.emlId || isAble.telNo}
          >
            {t("btn_regi_cmm")}
          </button>
        </div>
      </form>
    </>
  );
}
